import { customPaymentMethods } from "@jti/fe-common/types";

import type { PaymentOption } from "../../components/PaymentMethodsSection";

export const shouldShowPodSeparator = ({
  option,
  index,
  paymentOptionsLength,
  isIteration3Enabled,
}: {
  option: PaymentOption;
  index: number;
  paymentOptionsLength: number;
  isIteration3Enabled: boolean;
}) => {
  const isLastPaymentOption = index === paymentOptionsLength - 1;
  const hasMultiplePaymentOptions = paymentOptionsLength > 1;
  const isPodPaymentOption = option.code === customPaymentMethods.payOnDelivery;

  return isIteration3Enabled && hasMultiplePaymentOptions && isLastPaymentOption && isPodPaymentOption;
};
